namespace SolovisGateway.Admin.Organizations {

    export interface OrgConnectionActionsControlOptions extends Solovis.UI.BaseControlOptions {
        connectionId: number;
        connectionStatus: string;
        configureButtonLabel: string;
        onConfigure?: () => void;
        onValidateConnection?: () => void;
        onEnable?: () => void;
        onDisable?: () => void;
    }

    interface ConnectionActionState {
        configureDisabled: boolean;
        validateConnectionDisabled: boolean;
        enableDisabled: boolean;
        disableDisabled: boolean;
    }

    var connectionActionStates: { [status: string]: ConnectionActionState } = {
        Draft: {
            configureDisabled: false,
            validateConnectionDisabled: false,
            enableDisabled: true,
            disableDisabled: true
        },
        "Test Link Generated": {
            configureDisabled: false,
            validateConnectionDisabled: false,
            enableDisabled: false,
            disableDisabled: true
        },
        Enabled: {
            configureDisabled: false,
            validateConnectionDisabled: true,
            enableDisabled: true,
            disableDisabled: false
        },
        Disabled: {
            configureDisabled: false,
            validateConnectionDisabled: false,
            enableDisabled: false,
            disableDisabled: true
        }
    };

    export class OrgConnectionActionsControl extends Solovis.UI.BaseControl {

        private _options: OrgConnectionActionsControlOptions;

        constructor(options: OrgConnectionActionsControlOptions) {
            super(options);
            this._options = options;
        }

        public doRender() {
            let actionState = connectionActionStates[this._options.connectionStatus] || {
                configureDisabled: true,
                validateConnectionDisabled: true,
                enableDisabled: true,
                disableDisabled: true
            };

            this._buildButton(
                this._options.configureButtonLabel,
                actionState.configureDisabled,
                this._options.onConfigure
            ).appendTo(this.container);

            this._buildButton(
                "Validate Connection",
                actionState.validateConnectionDisabled,
                this._options.onValidateConnection
            ).appendTo(this.container);

            this._buildButton(
                "Enable",
                actionState.enableDisabled,
                this._options.onEnable
            ).appendTo(this.container);

            this._buildButton(
                "Disable",
                actionState.disableDisabled,
                this._options.onDisable
            ).appendTo(this.container);
        }

        private _buildButton(text: string, disabled: boolean, click?: () => void): JQuery {
            let button = new Solovis.UI.Buttons.Button({
                text: text,
                size: "small",
                click: function () {
                    if (click) {
                        click();
                    }
                }
            });

            let buttonElement = button.getElement();
            this._setButtonDisabled(buttonElement, disabled);
            return buttonElement;
        }

        private _setButtonDisabled(buttonElement: JQuery, disabled: boolean) {
            buttonElement.prop("disabled", disabled);

            if (disabled) {
                buttonElement.css({ "opacity": "0.65", "cursor": "not-allowed" });
            }
            else {
                buttonElement.css({ "opacity": "", "cursor": "" });
            }
        }
    }
}
